export default "__VITE_ASSET__CtbHL7l___"